import React from "react";

function Footer() {

    return (
        <nav className="navbar fixed-bottom navbar-dark bg-dark justify-content-center">
            <span className="navbar-brand footer-font blue align-middle">
                Copyright &copy;2021 | Andrés Ramírez</span>
        </nav>
    )
}



export default Footer;